import { OfficeAccountingTableHeader } from "./officeAccountingConsts";

export type OfficeAccountingColumnConfig = {
  title: string;
  id: string;
  width?: number;
};

const defaultWidth = 5;

export const officeAccountingAllFieldsList: OfficeAccountingColumnConfig[] = OfficeAccountingTableHeader.map((column) => ({
  title: column.title,
  id: column.id,
  width: defaultWidth,
}));

/** Default visible columns through Current Semester + Status. */
const defaultVisibleColumnIds = [
  "id",
  "fullName",
  "comments",
  "campus",
  "country",
  "dateOfBirth",
  "passportNo",
  "passportIssued",
  "validPassport",
  "phone",
  "email",
  "managersEmail",
  "agentsEmail",
  "course",
  "fieldOfStudy",
  "formOfEducation",
  "duration",
  "mediumOfInstruction",
  "admissionSemester",
  "intake",
  "currentSemester",
  "generalStatus",
];

export const officeAccountingDefaultConfiguration: OfficeAccountingColumnConfig[] = defaultVisibleColumnIds
  .map((id) => officeAccountingAllFieldsList.find((col) => col.id === id))
  .filter((col): col is OfficeAccountingColumnConfig => col != null);

export const OFFICE_ACCOUNTING_GENERAL_STATUS_NON_SORTED = "Non Sorted";

export const officeAccountingGeneralStatusConst = [
  { id: "active", label: "Active" },
  { id: "on_leave", label: "On leave" },
  { id: "graduated", label: "Graduated" },
  { id: "non_sorted", label: OFFICE_ACCOUNTING_GENERAL_STATUS_NON_SORTED },
] as const;

export const resolveOfficeAccountingGeneralStatusLabel = (value: string | null | undefined): string => {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) return OFFICE_ACCOUNTING_GENERAL_STATUS_NON_SORTED;
  const match = officeAccountingGeneralStatusConst.find(
    (status) => status.label.toLowerCase() === trimmed.toLowerCase() || status.id === trimmed.toLowerCase(),
  );
  return match?.label ?? trimmed;
};

export const resolveOfficeAccountingGeneralStatusId = (value: string | null | undefined): string => {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) return "non_sorted";
  const match = officeAccountingGeneralStatusConst.find(
    (status) => status.label.toLowerCase() === trimmed.toLowerCase() || status.id === trimmed.toLowerCase(),
  );
  return match?.id ?? "non_sorted";
};

export const formatOfficeAccountingGeneralStatusForApi = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed || trimmed === OFFICE_ACCOUNTING_GENERAL_STATUS_NON_SORTED) return "";
  return resolveOfficeAccountingGeneralStatusLabel(trimmed);
};

export const officeAccountingFilterStatusesConst = ["All", "Active", "On leave", "Graduated"];

export const officeAccountingHeaderSelectConst = [
  { id: "ALL", title: "All" },
  { id: "MALTA", title: "Malta" },
  { id: "POLAND", title: "Poland" },
  { id: "UKRAINE", title: "Ukraine" },
];
